import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  UpparbetadeKostnaderImportReasoningEffort,
  UpparbetadeKostnaderImportResult,
  UpparbetadeKostnaderSlotSchema,
} from '../../components/question/budget/upparbetade-kostnader-import/upparbetade-kostnader-import.interface';
import { projektApiUrl } from '../tokens/projekt-api-url-token';

/** Always available wherever the host app provides the projektApiUrl token (see SigneringClient) — Rapport-only feature, no per-app override needed. */
@Injectable({
  providedIn: 'root',
})
export class UpparbetadeKostnaderImportClient {
  private readonly projektApiUrl = inject<string>(projektApiUrl);
  private readonly httpClient = inject(HttpClient);

  importUpparbetadeKostnader(
    rapportId: string,
    file: File,
    schema: UpparbetadeKostnaderSlotSchema,
    reasoningEffort?: UpparbetadeKostnaderImportReasoningEffort,
    deployment?: string,
    preprocessing?: boolean,
  ): Observable<UpparbetadeKostnaderImportResult> {
    const url = `${this.projektApiUrl}/rapport/${rapportId}/upparbetadekostnader/import`;
    const formData = new FormData();
    formData.append('input', file, file.name);
    formData.append('schema', JSON.stringify(schema));
    if (reasoningEffort) {
      formData.append('reasoningEffort', reasoningEffort);
    }
    if (deployment) {
      formData.append('deployment', deployment);
    }
    if (preprocessing !== undefined) {
      formData.append('preprocessing', String(preprocessing));
    }

    return this.httpClient.post<UpparbetadeKostnaderImportResult>(
      url,
      formData,
    );
  }
}
